"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CollectibleERC1155ContractClass = exports.CollectibleERC721ContractClass = exports.CollectibleERC721SharedContractClass = exports.CollectibleContract = void 0;
var ethers_1 = require("ethers");
var CollectibleERC721Contract_json_1 = __importDefault(require("@manifoldxyz/typed-contracts/abis/CollectibleERC721Contract.json"));
var CollectibleERC721SharedContract_json_1 = __importDefault(require("@manifoldxyz/typed-contracts/abis/CollectibleERC721SharedContract.json"));
var CollectibleERC1155Contract_json_1 = __importDefault(require("@manifoldxyz/typed-contracts/abis/CollectibleERC1155Contract.json"));
var DutchAuctionABI_json_1 = __importDefault(require("../abis/DutchAuctionABI.json"));
var types_1 = require("../types");
/**
 * This class holds all key contract interactions which behind the scenes also often need to
 * interact with the collectible-server.
 *
 * Think of it as a wrapper around contract functionality. Each version of the contract extends
 * this base class and helps to standardize certain methods.
 *
 * Pretty much all contract interactions should happen through this class although the raw contract
 * instance is publicly exposed.
 */
var CollectibleContract = /** @class */ (function () {
    function CollectibleContract(store, dataProviders) {
        this.store = store;
        this.dataProviders = dataProviders;
        this._contractStateChangeListeners = new Set();
    }
    CollectibleContract.create = function (store, dataProviders) {
        if (store.state.isSharedContract && store.state.contractType === 'erc721') {
            return new CollectibleERC721SharedContractClass(store, dataProviders);
        }
        else if (store.state.isSharedContract && store.state.contractType === 'erc1155') {
            throw new Error('Shared ERC1155 contracts are not supported yet.');
        }
        else if (store.state.contractType === 'erc721') {
            return new CollectibleERC721ContractClass(store, dataProviders);
        }
        else if (store.state.contractType === 'erc1155') {
            return new CollectibleERC1155ContractClass(store, dataProviders);
        }
        else {
            throw new Error("Unsupported contract type. contractType must be one of \"erc721\" or \"erc1155\", received: ".concat(store.state.contractType));
        }
    };
    // Call this function to subscribe to contract state changes.
    CollectibleContract.prototype.onContractStateChange = function (callbackFn) {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_b) {
                if (!((_a = window.ManifoldEthereumProvider) === null || _a === void 0 ? void 0 : _a.provider()) ||
                    !this.contractInstance ||
                    this._contractStateChangeListeners.has(callbackFn)) {
                    return [2 /*return*/];
                }
                this.bindListeners(callbackFn);
                this._contractStateChangeListeners.add(callbackFn);
                return [2 /*return*/];
            });
        });
    };
    CollectibleContract.prototype.resetContractInstance = function () {
        // Skip resetting the contract instance in test as our mock implementations are tied to it.
        if (typeof jest === 'undefined') {
            // @ts-ignore
            this._contractInstance = null;
        }
    };
    CollectibleContract.prototype.state = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, contractState, pricingData, mintFee, transformedContractState;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, Promise.all([
                            this.contractState(),
                            this.pricingData(),
                            this.mintFee(),
                        ])];
                    case 1:
                        _a = _b.sent(), contractState = _a[0], pricingData = _a[1], mintFee = _a[2];
                        if (!!contractState) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.fetchContractStateFromServer()];
                    case 2:
                        contractState = (_b.sent());
                        _b.label = 3;
                    case 3:
                        transformedContractState = this.transformContractState(contractState);
                        return [2 /*return*/, __assign(__assign({}, transformedContractState), { pricingData: pricingData
                                    ? __assign({ type: types_1.PricingType.DUTCH_AUCTION }, pricingData) : undefined, mintFee: mintFee })];
                }
            });
        });
    };
    CollectibleContract.prototype.pricingData = function () {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var provider, e_1, response, e_2;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (this.store.state.pricingType !== types_1.PricingType.DUTCH_AUCTION) {
                            return [2 /*return*/, null];
                        }
                        provider = (_a = window.ManifoldEthereumProvider) === null || _a === void 0 ? void 0 : _a.provider();
                        if (!(provider && this.contractInstance)) return [3 /*break*/, 4];
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.contractInstance.pricingData()];
                    case 2: return [2 /*return*/, _b.sent()];
                    case 3:
                        e_1 = _b.sent();
                        console.error('Error fetching price data from contract: ', e_1);
                        return [3 /*break*/, 4];
                    case 4:
                        _b.trys.push([4, 7, , 8]);
                        return [4 /*yield*/, this.dataProviders.collectibleServerAPI.fetchCollectionPricingData(this.store.state.collectibleId, 'dutch-auction')];
                    case 5:
                        response = _b.sent();
                        return [4 /*yield*/, response.json()];
                    case 6: return [2 /*return*/, _b.sent()];
                    case 7:
                        e_2 = _b.sent();
                        throw new Error("Cannot fetch pricing data from Server. ".concat(e_2.message));
                    case 8: return [2 /*return*/];
                }
            });
        });
    };
    CollectibleContract.prototype.fetchContractStateFromServer = function () {
        return __awaiter(this, void 0, void 0, function () {
            var e_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.dataProviders.collectibleServerAPI.fetchCollectionData(this.store.state.collectibleId)];
                    case 1: return [2 /*return*/, _a.sent()];
                    case 2:
                        e_3 = _a.sent();
                        throw new Error("Unable to fetch state from contract nor server. Are you sure the contract address is correct? ".concat(e_3.message));
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    CollectibleContract.prototype.transformContractState = function (contractState) {
        // There's a number of numeric indices that gets merged into the contract state, this little snipper removes them.
        var contractStateWithNumericIndicesRemoved = Object.keys(contractState).reduce(function (acc, key) {
            if (/^\d+$/.test(key)) {
                return acc;
            }
            acc[key] = contractState[key];
            return acc;
        }, {});
        var _a = contractStateWithNumericIndicesRemoved, _b = _a.startTime, startTime = _b === void 0 ? '0' : _b, _c = _a.endTime, endTime = _c === void 0 ? '0' : _c, _d = _a.presaleInterval, presaleInterval = _d === void 0 ? '0' : _d, _f = _a.claimStartTime, claimStartTime = _f === void 0 ? '0' : _f, _g = _a.claimEndTime, claimEndTime = _g === void 0 ? '0' : _g, purchaseRemaining = _a.purchaseRemaining, restOfContractState = __rest(_a, ["startTime", "endTime", "presaleInterval", "claimStartTime", "claimEndTime", "purchaseRemaining"]);
        var startTimeDate = new Date(ethers_1.BigNumber.from(startTime).toNumber() * 1000);
        var endTimeDate = new Date(ethers_1.BigNumber.from(endTime).toNumber() * 1000);
        var claimStartTimeDate = new Date(ethers_1.BigNumber.from(claimStartTime || '0').toNumber() * 1000);
        var claimEndTimeDate = new Date(ethers_1.BigNumber.from(claimEndTime || '0').toNumber() * 1000);
        var presaleIntervalNum = ethers_1.BigNumber.from(presaleInterval).toNumber();
        var presaleEndTimeDate = new Date(startTimeDate.getTime() + presaleIntervalNum * 1000);
        return __assign(__assign({}, restOfContractState), { 
            // @ts-ignore
            active: contractState.active || contractState.isActive, tokensRemaining: ethers_1.BigNumber.from(purchaseRemaining !== null && purchaseRemaining !== void 0 ? purchaseRemaining : '0').toNumber(), startTime: startTimeDate, endTime: endTimeDate, presaleEndTime: presaleEndTimeDate, presaleInterval: presaleIntervalNum, claimStartTime: claimStartTimeDate, claimEndTime: claimEndTimeDate, isLoading: false });
    };
    CollectibleContract.prototype.mintFee = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, null];
            });
        });
    };
    return CollectibleContract;
}());
exports.CollectibleContract = CollectibleContract;
var CollectibleERC721SharedContractClass = /** @class */ (function (_super) {
    __extends(CollectibleERC721SharedContractClass, _super);
    function CollectibleERC721SharedContractClass() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(CollectibleERC721SharedContractClass.prototype, "contractABI", {
        get: function () {
            if (!this._contractABI) {
                this._contractABI = CollectibleERC721SharedContract_json_1.default;
            }
            return this._contractABI;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CollectibleERC721SharedContractClass.prototype, "contractInstance", {
        get: function () {
            var _a, _b;
            if (!this._contractInstance) {
                if (!this.store.state.sharedExtensionAddress) {
                    throw new Error('Shared extension address not set');
                }
                this._contractInstance = (_a = window.ManifoldEthereumProvider) === null || _a === void 0 ? void 0 : _a.contractInstance(this.store.state.sharedExtensionAddress, this.contractABI, Boolean((_b = window.ManifoldEthereumProvider) === null || _b === void 0 ? void 0 : _b.provider(true)));
            }
            return this._contractInstance;
        },
        enumerable: false,
        configurable: true
    });
    CollectibleERC721SharedContractClass.prototype.purchase = function (params, message, signature, nonce, overrides) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.contractInstance.purchase(this.store.state.collectibleAddress, this.store.state.collectibleInstanceId, params.quantity, message, signature, nonce, overrides)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    CollectibleERC721SharedContractClass.prototype.claim = function (params, message, signature, nonce, overrides) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.contractInstance.claim(this.store.state.collectibleAddress, this.store.state.collectibleInstanceId, params.quantity, message, signature, nonce, overrides)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    CollectibleERC721SharedContractClass.prototype.estimateGasForPurchase = function (params, message, signature, nonce, overrides) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.contractInstance.estimateGas.purchase(this.store.state.collectibleAddress, this.store.state.collectibleInstanceId, params.quantity, message, signature, nonce, overrides)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    CollectibleERC721SharedContractClass.prototype.estimateGasForClaim = function (params, message, signature, nonce, overrides) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.contractInstance.estimateGas.claim(this.store.state.collectibleAddress, this.store.state.collectibleInstanceId, params.quantity, message, signature, nonce, overrides)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    CollectibleERC721SharedContractClass.prototype.hasNonceBeenUsed = function (nonce) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.contractInstance.nonceUsed(this.store.state.collectibleAddress, this.store.state.collectibleInstanceId, nonce)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    CollectibleERC721SharedContractClass.prototype.parseMintedTokensFromTransactionReceipt = function (receipt) {
        var _this = this;
        var unveilEvents = receipt.logs.filter(function (log) { return log.topics[0] === _this.contractInstance.interface.getEventTopic('Unveil'); });
        var numMintedTokens = unveilEvents.length;
        var tokens = unveilEvents.map(function (log) {
            var args = _this.contractInstance.interface.parseLog(log).args;
            return {
                collectibleAddress: args.creatorContractAddress,
                collectibleInstanceId: args.instanceId,
                tokenId: args.tokenId.toString(),
                mintOrder: args.tokenMintIndex.toString(),
            };
        });
        return {
            numMintedTokens: numMintedTokens,
            tokens: tokens,
        };
    };
    CollectibleERC721SharedContractClass.prototype.bindListeners = function (callbackFn) {
        var UnveilFilter = this.contractInstance.filters.Unveil();
        this.contractInstance.on(UnveilFilter, callbackFn);
        this.contractInstance.on(this.contractInstance.filters.CollectibleActivated(), callbackFn);
        this.contractInstance.on(this.contractInstance.filters.CollectibleDeactivated(), callbackFn);
    };
    CollectibleERC721SharedContractClass.prototype.contractState = function () {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var provider, contractState, _e_1;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        provider = (_a = window.ManifoldEthereumProvider) === null || _a === void 0 ? void 0 : _a.provider();
                        if (!(provider && this.contractInstance)) return [3 /*break*/, 4];
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.contractInstance.state(this.store.state.collectibleAddress, this.store.state.collectibleInstanceId, {
                                from: this.store.state.walletAddress,
                            })];
                    case 2:
                        contractState = _b.sent();
                        return [2 /*return*/, contractState];
                    case 3:
                        _e_1 = _b.sent();
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/, null];
                }
            });
        });
    };
    CollectibleERC721SharedContractClass.prototype.mintFee = function () {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var e_4;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, ((_a = this.contractInstance) === null || _a === void 0 ? void 0 : _a.MINT_FEE())];
                    case 1: return [2 /*return*/, _b.sent()];
                    case 2:
                        e_4 = _b.sent();
                        console.warn('Error fetching mint fee from contract: ', e_4);
                        return [2 /*return*/, '690000000000000'];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    return CollectibleERC721SharedContractClass;
}(CollectibleContract));
exports.CollectibleERC721SharedContractClass = CollectibleERC721SharedContractClass;
var CollectibleERC721ContractClass = /** @class */ (function (_super) {
    __extends(CollectibleERC721ContractClass, _super);
    function CollectibleERC721ContractClass() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(CollectibleERC721ContractClass.prototype, "contractABI", {
        get: function () {
            if (!this._contractABI) {
                this._contractABI = CollectibleERC721Contract_json_1.default;
                if (this.store.state.pricingType === types_1.PricingType.DUTCH_AUCTION) {
                    this._contractABI = this._contractABI.concat(DutchAuctionABI_json_1.default);
                }
            }
            return this._contractABI;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CollectibleERC721ContractClass.prototype, "contractInstance", {
        get: function () {
            var _a, _b;
            if (!this._contractInstance) {
                this._contractInstance = (_a = window.ManifoldEthereumProvider) === null || _a === void 0 ? void 0 : _a.contractInstance(this.store.state.collectibleAddress, this.contractABI, Boolean((_b = window.ManifoldEthereumProvider) === null || _b === void 0 ? void 0 : _b.provider(true)));
            }
            return this._contractInstance;
        },
        enumerable: false,
        configurable: true
    });
    CollectibleERC721ContractClass.prototype.purchase = function (params, message, signature, nonce, overrides) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.contractInstance.purchase(params.quantity, message, signature, nonce, overrides)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    CollectibleERC721ContractClass.prototype.claim = function (params, message, signature, nonce, overrides) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.contractInstance.claim(params.quantity, message, signature, nonce, overrides)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    CollectibleERC721ContractClass.prototype.estimateGasForPurchase = function (params, message, signature, nonce, overrides) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.contractInstance.estimateGas.purchase(params.quantity, message, signature, nonce, overrides)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    CollectibleERC721ContractClass.prototype.estimateGasForClaim = function (params, message, signature, nonce, overrides) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.contractInstance.estimateGas.claim(params.quantity, message, signature, nonce, overrides)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    CollectibleERC721ContractClass.prototype.hasNonceBeenUsed = function (nonce) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.contractInstance.nonceUsed(nonce)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    CollectibleERC721ContractClass.prototype.parseMintedTokensFromTransactionReceipt = function (receipt) {
        var _this = this;
        var unveilEvents = receipt.logs.filter(function (log) { return log.topics[0] === _this.contractInstance.interface.getEventTopic('Unveil'); });
        var numMintedTokens = unveilEvents.length;
        var tokens = unveilEvents.map(function (log) {
            var args = _this.contractInstance.interface.parseLog(log).args;
            return {
                collectibleAddress: args.tokenAddress,
                tokenId: args.tokenId.toNumber(),
                mintOrder: args.collectibleId.toNumber(),
            };
        });
        return {
            numMintedTokens: numMintedTokens,
            tokens: tokens,
        };
    };
    CollectibleERC721ContractClass.prototype.bindListeners = function (callbackFn) {
        var UnveilFilter = this.contractInstance.filters.Unveil();
        this.contractInstance.on(UnveilFilter, callbackFn);
        this.contractInstance.on(this.contractInstance.filters.CollectionActivated(), callbackFn);
        this.contractInstance.on(this.contractInstance.filters.CollectionDeactivated(), callbackFn);
    };
    CollectibleERC721ContractClass.prototype.contractState = function () {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var provider, retVal, _e_2;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        provider = (_a = window.ManifoldEthereumProvider) === null || _a === void 0 ? void 0 : _a.provider();
                        if (!(provider && this.contractInstance)) return [3 /*break*/, 4];
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.contractInstance.state({
                                from: this.store.state.walletAddress,
                            })];
                    case 2:
                        retVal = (_b.sent());
                        return [2 /*return*/, retVal];
                    case 3:
                        _e_2 = _b.sent();
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/, null];
                }
            });
        });
    };
    return CollectibleERC721ContractClass;
}(CollectibleContract));
exports.CollectibleERC721ContractClass = CollectibleERC721ContractClass;
var CollectibleERC1155ContractClass = /** @class */ (function (_super) {
    __extends(CollectibleERC1155ContractClass, _super);
    function CollectibleERC1155ContractClass() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(CollectibleERC1155ContractClass.prototype, "contractABI", {
        get: function () {
            if (!this._contractABI) {
                this._contractABI = CollectibleERC1155Contract_json_1.default;
                if (this.store.state.pricingType === types_1.PricingType.DUTCH_AUCTION) {
                    this._contractABI = this._contractABI.concat(DutchAuctionABI_json_1.default);
                }
            }
            return this._contractABI;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CollectibleERC1155ContractClass.prototype, "contractInstance", {
        get: function () {
            var _a, _b;
            if (!this._contractInstance) {
                this._contractInstance = (_a = window.ManifoldEthereumProvider) === null || _a === void 0 ? void 0 : _a.contractInstance(this.store.state.collectibleAddress, this.contractABI, Boolean((_b = window.ManifoldEthereumProvider) === null || _b === void 0 ? void 0 : _b.provider(true)));
            }
            return this._contractInstance;
        },
        enumerable: false,
        configurable: true
    });
    CollectibleERC1155ContractClass.prototype.purchase = function (params, message, signature, nonce, overrides) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.contractInstance.purchase(params.quantity, message, signature, nonce, overrides)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    CollectibleERC1155ContractClass.prototype.claim = function (params, message, signature, nonce, overrides) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.contractInstance.claim(params.quantity, message, signature, nonce, overrides)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    CollectibleERC1155ContractClass.prototype.estimateGasForPurchase = function (params, message, signature, nonce, overrides) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.contractInstance.estimateGas.purchase(params.quantity, message, signature, nonce, overrides)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    CollectibleERC1155ContractClass.prototype.estimateGasForClaim = function (params, message, signature, nonce, overrides) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.contractInstance.estimateGas.claim(params.quantity, message, signature, nonce, overrides)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    CollectibleERC1155ContractClass.prototype.hasNonceBeenUsed = function (nonce) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.contractInstance.nonceUsed(nonce)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    CollectibleERC1155ContractClass.prototype.parseMintedTokensFromTransactionReceipt = function (receipt) {
        var _this = this;
        var transferSingleEvent = receipt.events.find(function (event) {
            return event.topics[0] ===
                _this.contractInstance.interface.getEventTopic('TransferSingle');
        });
        var numMintedTokens = this.contractInstance.interface
            .parseLog(transferSingleEvent)
            .args.value.toNumber();
        var tokens = [
            {
                /**
                 * For ERC1155 we're relying on the `fetchToken` API returning the default token
                 * metadata if the token ID does not exist, so that's the `0` value below. All we
                 * need for ERC1155's is the default token metadata since there's only 1 token.
                 */
                mintOrder: '0',
                tokenId: '0',
                collectibleAddress: '0',
            },
        ];
        return {
            numMintedTokens: numMintedTokens,
            tokens: tokens,
        };
    };
    CollectibleERC1155ContractClass.prototype.bindListeners = function (callbackFn) {
        var TransferSingleFilter = this.contractInstance.filters.TransferSingle();
        this.contractInstance.on(TransferSingleFilter, callbackFn);
        this.contractInstance.on(this.contractInstance.filters.CollectionActivated(), callbackFn);
        this.contractInstance.on(this.contractInstance.filters.CollectionDeactivated(), callbackFn);
    };
    CollectibleERC1155ContractClass.prototype.contractState = function () {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var provider, _e_3;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        provider = (_a = window.ManifoldEthereumProvider) === null || _a === void 0 ? void 0 : _a.provider();
                        if (!(provider && this.contractInstance)) return [3 /*break*/, 4];
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.contractInstance.state({
                                from: this.store.state.walletAddress,
                            })];
                    case 2: return [2 /*return*/, (_b.sent())];
                    case 3:
                        _e_3 = _b.sent();
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/, null];
                }
            });
        });
    };
    return CollectibleERC1155ContractClass;
}(CollectibleContract));
exports.CollectibleERC1155ContractClass = CollectibleERC1155ContractClass;
